module.exports = __webpack_public_path__ + "img/thermometer-50.88ff2a0d.svg";